import { Box, HStack, Heading, Icon, IconButton, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { MdCheck, MdContentCopy } from 'react-icons/md';

import Button from '../../../../components/ui/buttons/Button';
import { copyToClipboard } from '../../../../utils/copy';

type HeaderProps = {
  header: string;
  subtitle: string;
  isCobuyer?: boolean | null;
  isSoftClose: boolean;
  vin?: string | null;
  onSubtitleClick?: () => void;
};

const Header = ({
  header,
  subtitle,
  isCobuyer,
  isSoftClose,
  vin,
  onSubtitleClick,
}: HeaderProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopyVin = async () => {
    if (!vin) return;
    const success = await copyToClipboard(vin);
    if (success) {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }
  };

  return (
    <Box mb={8}>
      <Heading
        as="h1"
        fontWeight="bold"
        fontSize={{ base: '32px', md: '40px' }}
        lineHeight="1.2"
        color="leaseEndBlue"
        p={0}
      >
        {isCobuyer && isSoftClose ? 'Welcome to Your Co-Buyer Dashboard' : header}
      </Heading>
      {subtitle &&
        (onSubtitleClick ? (
          <Button fontSize="md" mt={1} variant="link" onClick={onSubtitleClick}>
            {subtitle} &darr;
          </Button>
        ) : (
          <Text fontSize="md" color="gray.500" mt={1}>
            {subtitle}
          </Text>
        ))}
      {vin && (
        <HStack
          spacing={1}
          bgColor="grayMediumBackground"
          px={3}
          py={1}
          mt={4}
          w="max-content"
          borderRadius="full"
        >
          <Text fontFamily="mono" color="taupeGray" fontSize="sm" letterSpacing="0.08em">
            VIN: {vin}
          </Text>
          <IconButton
            aria-label="Copy VIN"
            variant="ghost"
            size="xs"
            minW="auto"
            h="auto"
            p={0.5}
            color="taupeGray"
            _hover={{ color: 'gray.600' }}
            onClick={handleCopyVin}
            icon={<Icon as={copied ? MdCheck : MdContentCopy} boxSize="14px" />}
          />
        </HStack>
      )}
    </Box>
  );
};

export default Header;
